'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Digital Signature SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'All About Digital Signatures',
            subtitle: 'Ready to start eSigning with HelloSign?',
            buttonText: 'IT\'S ALWAYS FREE TO TRY!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'What is a digital signature?'), _jsx('p', {}, void 0, 'A digital signature refers to a set of algorithms and encryption protections used to determine the authenticity of a document or software.'), _jsx('p', {}, void 0, 'In simpler terms, a digital signature is a complicated way to verify that a document hasn’t been tampered with during transit between sender and signer.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Does HelloSign provide digital signatures?'), _jsx('p', {}, void 0, 'HelloSign provides ', _jsx('a', {
            href: '/electronic-signature',
            target: '_blank'
        }, void 0, 'electronic signatures'), '. HelloSign electronic signatures are legally binding and protected with bank-level security. By and large, anyone requesting or signing a document is using an electronic signature. Our security ensures that all documents are kept secure and protected. These security features include:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Secure data storage'), _jsx('li', {}, void 0, 'SSL hosting'), _jsx('li', {}, void 0, 'Audit-trails with time stamps'), _jsx('li', {}, void 0, 'Features like two-factor authentication')), _jsx('p', {}, void 0, 'You can read more about the ', _jsx('a', {
            href: '/info/security',
            target: '_blank'
        }, void 0, 'legality and security of electronic signatures here'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How do HelloSign electronic signatures work?'), _jsx('p', {}, void 0, 'HelloSign electronic signatures allow you to legally sign documents online, send signature requests to others for signing, and track the progress of any document. Here are just some of the places you’ll see electronic signatures used:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'NDAs and release forms'), _jsx('li', {}, void 0, 'Vendor paperwork and other complicated applications'), _jsx('li', {}, void 0, 'Proposals and sales contracts')), _jsx('p', {}, void 0, 'Happy users of HelloSign’s electronic signatures include the BBB, Samsung, and Twitter.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Digital signature vs. electronic signature'), _jsx('p', {}, void 0, 'While most people use the terms interchangeably, there is a difference between the two. An electronic signature refers to a protected and legally binding online signature. A digital signature refers to a complicated method for authenticating a document.'), _jsx('p', {}, void 0, 'For the most part, people are looking for an electronic signature when they’re searching for digital signatures.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Who’s using HelloSign signatures?'), _jsx('p', {}, void 0, 'HelloSign integrates with different companies to make signing as simple and easy as possible. We’re happy to partner with:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Google (including ', _jsx('a', {
            href: 'https://www.hellosign.com/gmail',
            target: '_blank'
        }, void 0, 'Gmail'), ', ', _jsx('a', {
            href: 'https://www.hellosign.com/googledrive',
            target: '_blank'
        }, void 0, 'Google Drive'), ', and ', _jsx('a', {
            href: 'https://www.hellosign.com/google-docs-add-on',
            target: '_blank'
        }, void 0, 'Google Docs'), ')'), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
            target: '_blank'
        }, void 0, 'Evernote')), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/dropbox/',
            target: '_blank'
        }, void 0, 'Dropbox')), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
            target: '_blank'
        }, void 0, 'Slack')), _jsx('li', {}, void 0, 'Zapier'), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
            target: '_blank'
        }, void 0, 'HubSpot CRM'))));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get started: eSign a document for free',
            subtitle: 'Now that you’re more familiar with electronic and digital signatures, try eSigning out for yourself! Or if you want to learn more about HelloSign eSignatures, schedule a live demo. We’ll walk you through our features and integrations.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/digital-signature.jsx
 ** module id = 828
 ** module chunks = 0
 **/